<template>
  <div class="z-10">
    <div
      class="flex flex-row modal-container"
      :class="{'hidden': !isShown}"
    >
      <div class="data-container">
        <div class="data-header">
          <p class="font-semibold text-3xl">
            List Notifications
          </p>
          <div
            class="self-center"
            @click="$emit('update:isShown', false)"
          >
            <vs-icon
              icon="close"
              color="#FF7F57"
              class="icon-transparent-bg"
            />
          </div>
        </div>
        <div v-if="data.length">
          <div
            v-for="(item, index) of data"
            :key="index"
            class="data-item"
          >
            <div class="flex flex-row items-center">
              <div class="w-full flex flex-row">
                <div class="w-1/12 data-icon-bg">
                  <div class="h-8 w-8 flex justify-center items-center">
                    <img
                      class="w-6"
                      :src="require('../../assets/shipo-icon-notification.svg')"
                    >
                  </div>
                </div>
                <div class="w-11/12 flex flex-col">
                  <p class="w-full flex flex-row flex-wrap flex-gap">
                    <span class="font-semibold text-primary">{{ item.tug_name }}</span>
                    &nbsp;
                    <span>with trip number</span>
                    &nbsp;
                    <span class="font-semibold text-danger">{{ item.trip_number }}</span>
                    &nbsp;
                    <span>is approaching to</span>
                    &nbsp;
                    <span class="font-semibold text-primary">{{ item.port }}</span>
                  </p>
                </div>
              </div>
            </div>
            <div class="flex flex-row">
              <div class="w-full my-5 custom-card">
                <div>
                  <p class="font-semibold text-sm text-grey-001">
                    Detail
                  </p>
                  <vs-divider
                    border-style="dashed"
                    class="my-2"
                  />
                </div>
                <div class="card-body">
                  <div class="card-body-content">
                    <span class="w-1/2 px-3">Port</span>
                    <span class="w-1/2 px-3 font-semibold text-primary">{{ item.port }}</span>
                  </div>
                  <div class="card-body-content">
                    <span class="w-1/2 px-3">Trip Number</span>
                    <span class="w-1/2 px-3 font-semibold text-primary">{{ item.trip_number }}</span>
                  </div>
                  <div class="card-body-content">
                    <span class="w-1/2 px-3">Tug Name</span>
                    <span class="w-1/2 px-3 font-semibold text-primary">{{ item.tug_name }}</span>
                  </div>
                  <div class="card-body-content">
                    <span class="w-1/2 px-3">ETA</span>
                    <span class="w-1/2 px-3 font-semibold text-primary">
                      {{ item.eta ? moment(item.eta).format('DD-MMM-YYYY HH:mm') : '-' }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p
          v-else
          class="self-center font-semibold italic text-secondary"
        >
          No Notifications can be shown
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    isShown: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
}

.modal-container {
  @apply w-full h-full fixed top-0 left-0 justify-end bg-black bg-opacity-50;

  z-index: 1000;
}

.data-container {
  @apply w-1/4 min-h-screen flex flex-col overflow-auto;

  background-color: #F1F1FD;
}

.data-header {
  @apply p-5 mb-5 flex flex-row justify-between rounded-b-2xl bg-white;
}

.data-item {
  @apply px-12 flex flex-col;
}

.data-icon-bg {
  @apply p-2 mr-3 flex flex-col justify-center rounded-lg bg-white;

  max-height: 35px;
}

.icon-transparent-bg {
  @apply p-1 flex flex-col justify-center rounded-lg cursor-pointer;

  background-color: rgba(255, 127, 87, 0.2);
}

.divider {
  @apply h-10;

  border-left: solid 1px #CDC6E1;
}

.divider-grow {
  border-left: solid 1px #CDC6E1;
}

.custom-card {
  @apply p-3 flex flex-col rounded-xl bg-white;
}

.card-body {
  @apply flex flex-col;
}

.card-body-content {
  @apply flex flex-row items-center py-1;
}

.flex-gap {
  grid-row-gap: 2px;
}
</style>
